import { useEffect, useRef } from 'react';

// Single hook used by all TradingView embedded widgets. Owns script injection
// AND cleanup — every prior implementation leaked the injected <script> on
// unmount, which accumulated duplicates whenever the user navigated back to a
// route that mounted one of these.

export function useTradingViewWidget(scriptName: string, config: object) {
  const ref = useRef<HTMLDivElement>(null);
  // Serialise config so the effect re-runs when the caller changes it. JSON
  // stringify is fine for the shallow configs all our widgets pass.
  const configKey = JSON.stringify(config);

  useEffect(() => {
    const container = ref.current;
    if (!container) return;
    const script = document.createElement('script');
    script.src = `https://s3.tradingview.com/external-embedding/${scriptName}.js`;
    script.async = true;
    script.type = 'text/javascript';
    script.text = configKey;
    container.appendChild(script);
    return () => {
      // Remove the injected script and any iframe TradingView attached. Without
      // this the DOM accumulates iframes on every route change.
      container.replaceChildren();
    };
  }, [scriptName, configKey]);

  return ref;
}
